import 'react-app-polyfill/stable';

import { letsDooray } from './LetsDooray';

const isIE = () => {
  var agent = navigator.userAgent.toLowerCase();
  return (navigator.appName === 'Netscape' && agent.indexOf('trident') !== -1) || agent.indexOf('msie') !== -1;
};

document.title = process.env.REACT_APP_MESSENGER_TITLE;

if (isIE()) {
  require('./ieContent');
} else {
  require('./main');
}

letsDooray();
